module.exports = ["A +","A -","B +","B -","AB +","AB -","O +","O -","Unknown"]


//////////////////
// WEBPACK FOOTER
// ./src/data/bloodTypes.json
// module id = 896
// module chunks = 0